import React from "react"

const { Container , Row , Col  , Card , CardBody

} = require("reactstrap")
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { useQuery } from "react-query"
import {  getWaitList } from "helpers/fakebackend_helper"


const WaitList = () => {

 
    const { data, isLoading } = useQuery('waitlist', getWaitList, {
        // staleTime: 120000,
          refetchOnWindowFocus: false,
        });
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Wait List" breadcrumbItem="Wait List" />
                    <Row>
                        <Col >
                            <Card>
                                <CardBody>
                                    {isLoading ? (
                                        <div>Loading...</div>
                                    ) : !data ? (
                                        <div>No waitlist available.</div>
                                    ) : (
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Email</th>
                                                    <th scope="col">Number of children</th>
                                                    <th scope="col">Requested At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map(request => (
                                                    <tr key={request.id}>
                                                        <td>{request.id}</td>
                                                        <td>{request.name}</td>
                                                        <td>{request.email}</td>
                                                        <td>{request?.number_of_children	}</td>
                                                        <td>{new Date(request.created_at).toLocaleString()}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }

export default WaitList;

